import React from "react";
import styles from "./RemoveUser.module.css";
import RemoveUserCard from "./RemoveUserCard/RemoveUserCard";
import { ClientUserDisplayInfoWithRoles } from "../../../../Types/ClientUserDisplayInfo";
//Components
//Data

type RemoveUserProps = {
  users: ClientUserDisplayInfoWithRoles[];
  handleRemoveUserFromList: (user: ClientUserDisplayInfoWithRoles) => void;
  areaId?: string;
  disabled?: boolean;
  onRemove?: (user: ClientUserDisplayInfoWithRoles) => Promise<void>;
  membershipLabel?: string;
};

const RemoveUser = ({ users, handleRemoveUserFromList, areaId, disabled = false, onRemove, membershipLabel }: RemoveUserProps) => {
  return (
    <div className={styles.container}>
      <h3>Remove Users</h3>
      <div className={styles.userList}>
        {users.map((user) => {
          return (
            <RemoveUserCard
              key={user.sub}
              user={user}
              handleRemoveUserFromList={handleRemoveUserFromList}
              areaId={areaId}
              disabled={disabled}
              onRemove={onRemove}
              membershipLabel={membershipLabel}
            />
          );
        })}
      </div>
    </div>
  );
};

export default RemoveUser;
